import type { ISelectionResult } from './ISelectionResult'

export default class CheckBoxSelectionResult implements ISelectionResult {
  constructor(selectionStrings: string[]) {
    this.selectionStrings = selectionStrings
  }

  public selectionStrings: string[]
}
